import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, Progress } from 'antd'

// Xác nhận giao may (bottom sheet trên điện thoại). Khi đang gửi: hiện tiến độ tải ảnh, khoá nút để không gửi 2 lần.
const ConfirmModal = ({ visible, partnerName, username, batches, totalItems, submitting, uploadPercent, onOk, onCancel }) => (
    <Modal
        visible={visible}
        title="Xác nhận giao may"
        footer={null}
        onCancel={submitting ? undefined : onCancel}
        closable={!submitting}
        maskClosable={!submitting}
        width={480}
        wrapClassName="HandoverConfirmModal"
    >
        <dl className="HandoverConfirmModal-info">
            <dt>Đối tác may</dt>
            <dd>{partnerName || '—'}</dd>
            <dt>Số lô</dt>
            <dd>{batches.length}</dd>
            <dt>Tổng item</dt>
            <dd>{totalItems}</dd>
            <dt>Người giao</dt>
            <dd>{username || '—'}</dd>
        </dl>

        <ul className="HandoverConfirmModal-list">
            {batches.map(batch => (
                <li key={batch.name}>
                    <span className="HandoverConfirmModal-name">{batch.name}</span>
                    <span className="HandoverConfirmModal-sku">{batch.sku || '—'} · {batch.items}</span>
                </li>
            ))}
        </ul>

        {submitting ? (
            <div className="HandoverConfirmModal-progress">
                <Progress percent={uploadPercent} status="active" />
                <small>
                    {uploadPercent < 100
                        ? `Đang tải ${batches.filter(batch => batch.hasImage).length} ảnh lệnh may lên...`
                        : 'Đang giao may...'}
                </small>
            </div>
        ) : (
            <div className="HandoverConfirmModal-note">
                Tất cả lô được giao cùng lúc. Nếu có lô không còn hợp lệ, hệ thống không giao lô nào.
            </div>
        )}

        <div className="HandoverConfirmModal-actions">
            <Button size="large" disabled={submitting} onClick={onCancel}>Huỷ</Button>
            <Button type="primary" size="large" loading={submitting} onClick={onOk}>
                {submitting ? 'Đang giao...' : 'Xác nhận giao may'}
            </Button>
        </div>
    </Modal>
)

ConfirmModal.propTypes = {
    visible: PropTypes.bool.isRequired,
    partnerName: PropTypes.string,
    username: PropTypes.string,
    // [{ name, sku, items, hasImage }] — các lô hợp lệ sẽ giao, theo thứ tự chụp; hasImage = false: dòng nhập tay
    batches: PropTypes.array.isRequired,
    totalItems: PropTypes.number.isRequired,
    submitting: PropTypes.bool,
    uploadPercent: PropTypes.number,
    onOk: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
}

ConfirmModal.defaultProps = {
    partnerName: '',
    username: '',
    submitting: false,
    uploadPercent: 0,
}

export default ConfirmModal
